export const Constants = {
  TAG_NAME: 'pop-state-diversification-component',
  COMPONENT_TITLE: 'State Diversification',
  DATA_AS_OF_DROPDOWN_LABEL: 'Data as of',
  DATA_AS_OF_DROPDOWN_ID: 'state-diversification-data-as-of-select',
} as const;
